/**
 * Handle File various status
 */
export enum FileStatus {
  PRINCIPAL = 'P',
  ANNEXE = 'A',
  DATA = 'D',
  SPOOL = 'S'
}
